import classnames from 'classnames/bind'

// Components
import FooterCompanyInfo from './CompanyInfo'
import ServiceList from './ServiceList'

// Styles
import styles from './style.module.scss'
const cx = classnames.bind(styles)

function Footer() {
  return (
    <div className={cx('footer')}>
      <div className={cx('footer__content')}>
        <FooterCompanyInfo className={cx('footer__content__company-info-desktop')} />
        <ServiceList />
        <FooterCompanyInfo className={cx('footer__content__company-info-mobile')} />
      </div>
    </div>
  )
}

export default Footer
